import React from 'react'
import Grid from '@material-ui/core/Grid'
import { Field } from 'react-final-form'
import {
  List,
  Filter,
  TextField,
  useListRepository,
  useFilter,
  Select
} from 'elentari'
import { useAbility } from '../Usuarios'
import { getListActions } from '../../lib/crudAuthorization'
import unidadeNegocioRepository from './unidadeNegocioRepository'
import EmpresaSelect from '../Empresa/EmpresaSelect'

const UnidadeNegocioFilter = () => {
  const filter = useFilter({})

  return (
    <Filter
      {...filter}
      labels={{
        simpleFilter: 'Busca simples',
        find: 'Buscar',
        clear: 'Limpar'
      }}
    >
      <Grid spacing={3} container>
        <Grid item sm={6} md={6} xs={12}>
          <Field
            fullWidth
            name="descricao"
            label="Descricao"
            component={TextField}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <EmpresaSelect />
        </Grid>
        <Grid item sm={3} xs={12}>
          <Field
            fullWidth
            hideEmpty
            component={Select}
            options={[
              { label: 'Ativo', value: true },
              { label: 'Inativo', value: false }
            ]}
            label="Status"
            name="status"
          />
        </Grid>
      </Grid>
    </Filter>
  )
}

const UnidadeNegocio = props => {
  const [ability] = useAbility()

  const listHook = useListRepository({
    repository: unidadeNegocioRepository,
    path: 'unidadeNegocio'
  })

  const listOptions = {
    fields: {
      descricao: {
        label: 'Descrição'
      },
      empresa: {
        label: 'Empresa',
        format: empresa => (empresa ? empresa.sigla : '-'),
        noOrder: true
      },
      status: {
        label: 'Status',
        format: value => (value ? 'Ativo' : 'Inativo')
      }
    }
  }

  const actions = getListActions(ability, listHook, 'unidadeNegocio')

  return (
    <>
      <UnidadeNegocioFilter />
      <List
        {...props}
        {...listHook}
        {...actions}
        stickyHeader
        adjustToScreenHeight
        onClickView={null}
        onClickRow={item => props.history.push(`/unidadeNegocio/${item.id}`)}
        removeItem={null}
        hideDownloadIcon
        listOptions={listOptions}
      />
    </>
  )
}

export default UnidadeNegocio
